"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Removes decimals from passed value
 * @param {string} value
 * @returns {number}
 */
function formatWithoutDecimals(value) {
    return Number(value.split(/\./)[0]);
}
exports.default = formatWithoutDecimals;
